const fetchFromNocoDB = async (endpoint) => {
  try {
    const response = await fetch(`/.netlify/functions/fetchFromNocodb?endpoint=${encodeURIComponent(endpoint)}`);

    const text = await response.text();
    // console.log("Raw response:", text); // Add this line for debugging

    if (!response.ok) {
      throw new Error(`Function fetch failed: ${response.status}`);
    }

    const data = JSON.parse(text); // Only try to parse once we know it's valid JSON
    return data;
  } catch (error) {
    console.error("Error fetching data from serverless function:", error);
    throw error;
  }
};


export const fetchNewsDatabase = () =>
  fetchFromNocoDB("https://app.nocodb.com/api/v2/tables/m975zrx7i2kj488/records?where=(published,is,true)&limit=1000");

export const fetchPublicationsDatabase = () =>
  fetchFromNocoDB("https://app.nocodb.com/api/v2/tables/mg3lr23rpoka8px/records?where=(published,is,true)&limit=1000");

export const fetchSoundsDatabase = () =>
  fetchFromNocoDB("https://app.nocodb.com/api/v2/tables/mug5mh5qyijbaw5/records?where=(published,is,true)&limit=1000");

export const fetchSessionsDatabase = () =>
  fetchFromNocoDB("https://app.nocodb.com/api/v2/tables/m7dimos4ocdtiup/records?sort=-year,-season&where=(published,is,true)&limit=1000");

export const fetchAteliersDatabase = () =>
  fetchFromNocoDB("https://app.nocodb.com/api/v2/tables/mfqedvdm4u7zzon/records?where=(published,is,true)&limit=1000");
